import styled from 'styled-components';
import React, {FC} from 'react';
import {
  fontSizesMixins,
  mediaBreakpointDown,
  fontFamiliesStrings,
  palette,
  fontWeights,
  transition
} from '../../lib/styleVariables';
import {rgba} from 'polished';
import warningFilled from '../../assets/images/warningFilled.svg';

const StyledSubscriptionForm = styled.div`
  /* Customizing HubSpot form styling below */

  #subscription-form {
    ${mediaBreakpointDown('tablet')} {
      width: 100%;
    }
  }

  #subscription-form input,
  #subscription-form label {
    font-family: ${fontFamiliesStrings.body};
  }

  #subscription-form input:not([type='submit']) {
    height: 40px;
    width: 100%;
    appearance: none;
    border: 0;
    outline: 0;
    background: no-repeat right 12px center;
    border-radius: 8px;
    border-width: 2px;
    border-style: solid;
    border-color: ${palette.blue.base};
    transition: all ${transition.fast} ease;
    padding: 8px 40px 8px 12px;
    color: ${palette.black.base};

    &::placeholder {
      color: ${rgba(palette.black.base, 0.4)};
    }

    &:disabled {
      background-color: ${palette.white.highlight};
      border-color: ${palette.white.base};

      cursor: not-allowed;
    }

    &.invalid {
      background-color: ${palette.red.highlight};
      border-color: ${palette.red.base};
      background-image: url(${warningFilled});

      &:focus {
        background: ${palette.white.highlight};
      }
    }
  }

  #subscription-form input[type='submit'] {
    ${fontSizesMixins.text3()};
    width: auto;
    border-radius: 48px;
    margin: 32px 0 0 0;
    padding: 11px 24px;
    border: none;
    background: ${palette.blue.base};
    box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.13);
    color: ${palette.white.base};
    cursor: pointer;
    font-weight: ${fontWeights.bold};
    transition: background ${transition.fast};
    display: block;

    &:hover {
      background: ${palette.black.base};
    }
  }

  #subscription-form .actions {
    margin: 0;
    padding: 0;
  }

  #subscription-form .hs-form-field label {
    ${fontSizesMixins.text3()};
    font-weight: ${fontWeights.bold};
    display: block;
  }

  #subscription-form .hs_error_rollup {
    display: none;
  }

  #subscription-form label.hs-error-msg,
  #subscription-form .hs_error_rollup label {
    ${fontSizesMixins.text4()};
    line-height: 136%;
    color: ${palette.red.base};
    font-weight: ${fontWeights.medium};
  }

  #subscription-form .hs-form-field {
    margin-bottom: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  #subscription-form .hs-form-field > label,
  #subscription-form .hs-form-field ul.hs-error-msgs {
    margin-bottom: 8px;
  }

  #subscription-form .hs-form-field .input {
    width: 100%;
    order: 2;
  }

  #subscription-form .hs-form-field input {
    width: 100%;
  }

  #subscription-form .hs-form-field ul,
  #subscription-form .hs-error-msgs {
    margin: 0;
    padding-left: 0;
    list-style: none;
  }

  #subscription-form .hs-richtext {
    display: none;
  }

  #subscription-form .submitted-message {
    ${fontSizesMixins.text3()};
    font-weight: ${fontWeights.medium};
    color: ${palette.black.base};
    font-family: ${fontFamiliesStrings.body};
    text-align: center;
  }
`;

const StyledFormTitle = styled.h3`
  ${fontSizesMixins.h3()};
  margin-top: 0;
  margin-bottom: 24px;

  ${mediaBreakpointDown('mobile')} {
    padding-right: 16px;
  }
`;

interface PropsType {
  title: string | null | undefined;
  subscriptionFormEmbedData: any;
}

export const SubscriptionForm: FC<PropsType> = ({title, subscriptionFormEmbedData}) => {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/v2.js';
    script.charset = 'utf-8';
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      window.hbspt.forms.create({
        target: '#subscription-form',
        ...subscriptionFormEmbedData
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <StyledSubscriptionForm>
      <StyledFormTitle>{title}</StyledFormTitle>
      <div id="subscription-form" className="hbspt-form" />
    </StyledSubscriptionForm>
  );
};
